import React from 'react';
import Slider from '../../components/Chart/chartSlider';

/*
props:
    windowHeight: Size of the window used by chart component.
    windowWidth: Size of the window used by chart component.
    chartData: All the data for the charts. 
    sizeCheck: A json object that informs what is the size of the screen in terms of mateerial-ui breakpoints
    updateTheNumberOfGeneratedCharts: function that informs chartView how many charts are displayed in order to export them all properly.
    updateSelectedSlide: function that informs chartView what is the chart that the user is viewing right now in order to export it.

JSON multipleChartData{
    [{
        id: id of the current chart.
        data: data of the current chart.
        title: title,
        xtitle: title of the x axis,
        ytitle: title of the y axis,
        minValue: minimum value for the y axis,
        maxValue: maximum value for the y axis,
        legendData: legends,
        chartType: type of chart
    }]
}
*/

class ChartSlider extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
            multipleChartData: [],
            currentSlide: 0,
            barWidth: 1,
            maxBarsPerSlide: 5,
            viewportWidth: 0
		};
        this.updateCurrentSlide = this.updateCurrentSlide.bind(this);
        this.calculateMaxBarsPerChartAndBarWitdh = this.calculateMaxBarsPerChartAndBarWitdh.bind(this);
	}

    calculateMaxBarsPerChartAndBarWitdh(){
        const viewportWidth = this.state.viewportWidth;
        const newViewportWidth = this.props.windowWidth;
        const sizeCheck = this.props.sizeCheck;
        const chartType = this.props.chartData.chartType;
        const legendSize = this.props.chartData.legendData.length;
        var barsPerSlide = 11;
        var barWidth = 35;
        var groupedchart = false;

        //this is a grouped simplebar so we can fit more bars into it because they are closer together
        if((chartType == "simplebar") && (legendSize > 1)){
            groupedchart = true;
        }

        if(sizeCheck["xlCheck"]){
            barsPerSlide = 18;
            barWidth = 35;
            if (groupedchart) {
                barsPerSlide = 23;
            }
        } else if (sizeCheck["lgCheck"]){
            barsPerSlide = 13;
            barWidth = 30;
            if (groupedchart) {
                barsPerSlide = 18;
            }
        } else if (sizeCheck["mdCheck"]){
            barsPerSlide = 15;
            barWidth = 30;
            if (groupedchart) {
                barsPerSlide = 20;
            }
        } else if (sizeCheck["smCheck"]){
            barsPerSlide = 10;
            barWidth = 25;
            if (groupedchart) {
                barsPerSlide = 11;
            }
        } else if (sizeCheck["xsCheck"]){
            barsPerSlide = 5;
            barWidth = 20;
            if (groupedchart) {
                barsPerSlide = 7;
            }
        }

        //the viewport might change only in height, in this case dont do anything as we only care about width
        if(viewportWidth != newViewportWidth){
            //setState is asynchronous so we need to call "separateDataIntoMultipleCharts" after the state is updated
            this.setState({
                barWidth: barWidth,
                maxBarsPerSlide: barsPerSlide,
                currentSlide: 0,
                viewportWidth: newViewportWidth,
            }, () => {
                this.separateDataIntoMultipleCharts();
            });
        }
        
    }
/*
    JSON multipleChartData{
        [{
            id: id of the current chart.
            data: data of the current chart.
            title: title,
            xtitle: title of the x axis,
            ytitle: title of the y axis,
            minValue: minimum value for the y axis,
            maxValue: maximum value for the y axis,
            legendData: legends,
            chartType: type of chart
        }]
    }
*/
    separateDataIntoMultipleCharts(){
        const data = this.props.chartData.data;
        const dataSize = this.props.chartData.data.length;
        const legend = this.props.chartData.legendData;
        const legendSize = this.props.chartData.legendData.length;
        const chartType = this.props.chartData.chartType;
        const maxBarsPerSlide = this.state.maxBarsPerSlide;

        var counter = 0;
        var bardata = [];
        var legendData = [];
        var i;
        var divID;
        var chartCounter = 0;
        var multipleChartData = [];
        var barsPerSlide;
        //this is a grouped simplebar and needs to be splited diferently, unless we can display whole groups
        //but the groups are bigger than the maximum amoun of bars we can put in a chart
        if((chartType == "simplebar") && (legendSize > 1) && (maxBarsPerSlide / legendSize < 1)){
            var j;
            var label;
            bardata = {};
            for (i=0; i < dataSize; i++){
                for (j=0; j < legendSize; j++){
                    if(counter < maxBarsPerSlide){ //acumulate bars and legends for current chart
                        label = legend[j]["name"];
                        bardata[label] = data[i][label];
                        legendData.push(legend[j]);
                        counter++;
                    } 
                    if(counter === maxBarsPerSlide) { // save chart
                        //add xaxis label
                        bardata["xaxi"] = data[i]["xaxi"];
                        divID = "chart-image-";
                        divID = divID + chartCounter;
                        multipleChartData.push({
                            "id": chartCounter,
                            "divID": divID,
                            "data": [bardata],
                            "title": this.props.chartData.title,
                            "xtitle": this.props.chartData.xtitle,
                            "ytitle": this.props.chartData.ytitle,
                            "minValue": this.props.chartData.minValue,
                            "maxValue": this.props.chartData.maxValue,
                            "legendData": legendData,
                            "chartType": chartType,
                        });
                        //reset for new chart
                        counter = 0;
                        chartCounter++;
                        bardata = {};
                        legendData = [];
                    }
                }
                if(Object.keys(bardata).length > 0){
                    bardata["xaxi"] = data[i]["xaxi"];
                    divID = "chart-image-";
                    divID = divID + chartCounter;
                    multipleChartData.push({
                        "id": chartCounter,
                        "divID": divID,
                        "data": [bardata],
                        "title": this.props.chartData.title,
                        "xtitle": this.props.chartData.xtitle,
                        "ytitle": this.props.chartData.ytitle,
                        "minValue": this.props.chartData.minValue,
                        "maxValue": this.props.chartData.maxValue,
                        "legendData": legendData,
                        "chartType": chartType,
                    });
                }
                counter = 0;
                chartCounter++;
                bardata = {};
                legendData = [];
            }
        } else { //because we dont have to plit the bar groups we can transfer them directly
            legendData = legend;
            //barsPerSlide need adjusting if we need to display groups of bars. 
            if((chartType == "simplebar") && (legendSize > 1)){
                barsPerSlide =  Math.floor(maxBarsPerSlide / legendSize); //we only need the integer part.
            } else {
                barsPerSlide = maxBarsPerSlide;
            }
            for (i=0; i < dataSize; i++){
                if(counter < barsPerSlide){ //acumulate bars for current chart
                    bardata.push(data[i]);
                    counter++;
                } 
                if(counter === barsPerSlide) { // save chart
                    divID = "chart-image-"
                    divID = divID + chartCounter;
                    multipleChartData.push({
                        "id": chartCounter,
                        "divID": divID,
                        "data": bardata,
                        "title": this.props.chartData.title,
                        "xtitle": this.props.chartData.xtitle,
                        "ytitle": this.props.chartData.ytitle,
                        "minValue": this.props.chartData.minValue,
                        "maxValue": this.props.chartData.maxValue,
                        "legendData": legendData,
                        "chartType": chartType,
                    });
                    //reset for new chart
                    counter = 0;
                    chartCounter++;
                    bardata = [];
                }
            }
            if(bardata.length > 0){
                divID = "chart-image-"
                divID = divID + chartCounter;
                multipleChartData.push({
                    "id": chartCounter,
                    "divID": divID,
                    "data": bardata,
                    "title": this.props.chartData.title,
                    "xtitle": this.props.chartData.xtitle,
                    "ytitle": this.props.chartData.ytitle,
                    "minValue": this.props.chartData.minValue,
                    "maxValue": this.props.chartData.maxValue,
                    "legendData": legendData,
                    "chartType": chartType,
                });
                //reset for new chart
                counter = 0;
                chartCounter++;
                bardata = [];
            }
        }
        this.setState({
            multipleChartData: multipleChartData
        });
        this.props.updateTheNumberOfGeneratedCharts(chartCounter);
        this.props.updateSelectedSlide(0);
    }
    
    componentDidMount(){
        this.calculateMaxBarsPerChartAndBarWitdh();
        window.addEventListener('resize', this.calculateMaxBarsPerChartAndBarWitdh);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.calculateMaxBarsPerChartAndBarWitdh);
      }

    updateCurrentSlide(value){
        // this function is to update what is the current slide in the chartView container.
        this.props.updateSelectedSlide(value);
        this.setState({
            currentSlide: value
        });
    }
	
	render() {
		const { multipleChartData, currentSlide, barWidth } = this.state;
		const { windowHeight, windowWidth } = this.props;
		return (
			<Slider
                currentSlide={currentSlide}
                multipleChartData={multipleChartData}
				height={windowHeight}
				width={windowWidth}
                barWidth={barWidth}
                updateCurrentSlide={this.updateCurrentSlide}
			/>

		)
	}
}

export default ChartSlider;